<template>
  <wptv-button
    :class="['alert-button', { 'registered' : isRegistered }]"
    type="wired"
    background="black"
    data-wptv="alert-button"
    @click.native="handleClick">
    {{ isRegistered ? $t('fip.buttons.deleteAlert') : $t('fip.buttons.setAlert') }}
  </wptv-button>
</template>

<script>
import { mapGetters } from 'vuex'
import { WptvButton } from '@wptv/components/ui/button'
import { WptvSnackbarConfig } from '@wptv/components/ui/snackbar'
import { accessChecks } from '../../../../../middleware/checkups'

export default {
  name: 'AlertButton',
  components: {
    WptvButton
  },
  props: {
    alert: {
      type: Object,
      required: true
    },
    video: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      profile: 'core/getProfile'
    }),
    isRegistered () {
      return Object.entries(this.alert).length !== 0
    }
  },
  methods: {
    handleClick () {
      return accessChecks(this.$store, this.profile, false, true, false, this.$route)
        .then(() => this.isRegistered ? this.deleteAlert() : this.setAlert())
    },
    setAlert () {
      this.sendStats(this.$stats.fip.onClickActiveAlertButton(this.video))
      return this.$store.dispatch('alerts/setAlert', this.video.id)
        .then(() => {
          this.$store.dispatch('alerts/getAlertById', this.video.id)
          this.$root.$emit('snackbar', {
            text: this.$t('myalerts.successAdd'),
            type: WptvSnackbarConfig.type.SUCCESS
          })
        })
        .catch((skipError = false) => {
          if (!skipError) {
            this.emitError()
          }
        })
    },
    deleteAlert () {
      this.sendStats(this.$stats.fip.onClickDeleteAlertButton(this.video))
      return this.$store.dispatch('alerts/deleteAlert', this.video.id)
        .then(() => {
          this.$root.$emit('snackbar', {
            text: this.$t('myalerts.successDelete'),
            type: WptvSnackbarConfig.type.SUCCESS
          })
        }).catch(() => this.emitError())
    },
    emitError () {
      this.$root.$emit('snackbar', {
        text: this.$t('myalerts.error'),
        type: WptvSnackbarConfig.type.ERROR
      })
    },
    getSnackbarPosition () {
      return {
        left: this.$el.getBoundingClientRect().left,
        bottom: 45,
        centeredX: false,
        centeredY: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-button {
  position: relative;
  z-index: 9;
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: bold;
  display: inline-block;
  line-height: 1em;
  padding: 14px 10px;
  max-width: unset !important;

  @include mediaQueries('margin-bottom', (large: 30px, xlarge: 44px));
  @include mediaQueries('margin-right', (medium: auto));
  @include mediaQueries('width', (xsmall: 100%, large: auto));

  .icon {
    margin-right: 5px;
  }

  &:hover {
    .icon {
      filter: invert(1);
    }
  }

  &:focus:not(:hover):not(:active),
  &:focus:active {
    .icon {
      filter: none;
    }
  }
}
</style>
